import Vue from 'vue'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const headerObservations = (data) => {
  const observations = data?.observations

  if (!observations) return ''

  return `
    <div class="d-block mt-3">
      <h6 class="text-uppercase grey--text mt-2">
        ${translate(area + 'observation')}
      </h6>
      <span class="body-2">
        ${observations}
      </span>
    </div>
  `
}

export default headerObservations
